import OfficeIcon from "assets/icons/home_work.svg?react";
import PersonIcon from "assets/icons/view_list.svg?react";
import FormStyleIcon from "assets/icons/palette.svg?react";
import ShareIcon from "assets/icons/language.svg?react";
import AddressBookIcon from "assets/icons/personal.svg?react";
import SharingIcon from "assets/icons/share.svg?react";
import { EWizardStep, IWizardStepDef } from "./typings";
import Step2Secretariat from "./steps/Step2Secretariat";
import Step3Recipients from "./steps/Step3Recipients";
import Step5FormStyle from "./steps/Step5FormStyle";
import Step6Publish from "./steps/Step6Publish";
import Step7AddressBook from "./steps/Step7AddressBook";
import Step8SafeEnvelope from "./steps/Step8SafeEnvelope";
import Step2Sharing from "./steps/Step2Sharing";

export const WIZARD_STEPS: IWizardStepDef[] = [
  {
    id: EWizardStep.FormStyle,
    titleKey: "contactFormWizard.steps.formStyle.title",
    descriptionKey: "contactFormWizard.steps.formStyle.description",
    Icon: FormStyleIcon,
    Component: Step5FormStyle,
    stageLabel: "Nadawanie – skrzynka na Twojej stronie",
  },
  {
    id: EWizardStep.Publish,
    titleKey: "contactFormWizard.steps.publish.title",
    descriptionKey: "contactFormWizard.steps.publish.description",
    Icon: ShareIcon,
    Component: Step6Publish,
  },
  {
    id: EWizardStep.SafeEnvelope,
    titleKey: "contactFormWizard.steps.safeEnvelope.title",
    descriptionKey: "contactFormWizard.steps.safeEnvelope.description",
    Icon: ShareIcon,
    Component: Step8SafeEnvelope,
    stageLabel: "Nadawanie – bezpieczna koperta",
  },
  {
    id: EWizardStep.Sharing,
    titleKey: "contactFormWizard.steps.sharing.title",
    descriptionKey: "contactFormWizard.steps.sharing.description",
    Icon: SharingIcon,
    Component: Step2Sharing,
    stageLabel: "Nadawanie – poprzez eSzyfrowane.pl",
  },
  {
    id: EWizardStep.AddressBook,
    titleKey: "contactFormWizard.steps.addressBook.title",
    descriptionKey: "contactFormWizard.steps.addressBook.description",
    Icon: AddressBookIcon,
    Component: Step7AddressBook,
  },
  {
    id: EWizardStep.Secretariat,
    titleKey: "contactFormWizard.steps.secretariat.title",
    descriptionKey: "contactFormWizard.steps.secretariat.description",
    Icon: OfficeIcon,
    Component: Step2Secretariat,
    stageLabel: "Odbieranie – konfiguracja skrzynek",
  },
  {
    id: EWizardStep.Recipients,
    titleKey: "contactFormWizard.steps.recipients.title",
    descriptionKey: "contactFormWizard.steps.recipients.description",
    Icon: PersonIcon,
    Component: Step3Recipients,
  },
];
